import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { stores } from "../stores";
import { ReadPresetButton } from "./ReadPresetButton";
import { ReadAllPresetsButton } from "./ReadAllPresetsButton";
import { Preset } from "./Preset";
import { SortableSelectorsList } from "./selectors/SortableSelectorsList";
import { Handle } from "./selectors/Handle";
import "./Presets.css";

export const Presets = observer(() => {
    stores.state.resetPresetSelectorsRefs();
    useEffect(() => {
        stores.state.selectPreset(stores.state.activePreset, true);
    }, []);

    const deviceType = stores.memory.getDeviceType();
    const isMicroGen3Or4 = deviceType === "DPC.micro Gen3" || deviceType === "DPC.micro Gen4";

    const MicroSpecificInfo = () => (
        <div className="mt-10 text-sm">
            <p>MIDI Programs 120-127 are not editable:</p>
            <ul className="list-disc pl-5 mt-2">
                <li>120: All loops off</li>
                <li>121: Loop A ON</li>
                <li>122: Loop B ON</li>
                <li>123: Loops A and B ON</li>
                <li>124: Loop C ON</li>
                <li>125: Loops A and C ON</li>
                <li>126: Loops B and C ON</li>
                <li>127: All loops ON</li>
            </ul>
        </div>
    );

    return (
        <div className="presets main-content flex">
            <SortableSelectorsList />
            <div className="right grow pl-20 scroll-y">
                <Preset />
            </div>
            <div className="right max-w-30 pl-20">
                <div className="mt-20 line-125">
                    You can re-order the presets with the <Handle /> handle.
                </div>
                <div className="mt-5 line-125">
                    Hold the <em>Ctrl (Windows)</em> or <em>Cmd (Mac)</em> key to copy over instead of swapping.
                </div>
                <div className="mt-5 line-125">
                    Preset #0 is the "bypass" sound loaded when preset mode LEDs are off.
                </div>
                <div className="mt-5 line-125">
                    {isMicroGen3Or4 
                        ? "Presets 1-9 are available on the device itself, presets 10-120 are accessible via MIDI."
                        : "Presets 1-48 are available on the device itself, presets 49-127 are accessible via MIDI."}
                </div>
                {isMicroGen3Or4 && <MicroSpecificInfo />}
                <div className="mt-20 row">
                    <ReadAllPresetsButton 
                        all={stores.state.showAllPresets}
                    />
                </div>
                <div className="mt-20">
                    <ReadPresetButton />
                </div>
                <div className="mt-20">
                    <button onClick={() => stores.state.toggleShowAllPresets()} className="w-full">
                        {stores.state.showAllPresets 
                            ? isMicroGen3Or4 ? 'Show 9 preset slots' : 'Show 48 preset slots'
                            : 'Show all preset slots'}
                    </button>
                </div>
            </div>
        </div>
    );
});